import { Calculator, ExternalLink } from 'lucide-react';
import { Button } from '../../ui';
import { navigationLinks } from '../../../data';

export interface NavigationProps {
    onCalculatorClick: () => void;
}

export function Navigation({ onCalculatorClick }: NavigationProps) {
    return (
        <nav className="flex gap-2 md:gap-3 flex-wrap items-center justify-center py-4">
            <Button
                onClick={onCalculatorClick}
                variant="primary"
                size="md"
                icon={<Calculator className="w-5 h-5" />}
                className="shadow-md hover:shadow-lg"
            >
                Calculeaza Asigurarea
            </Button>

            {navigationLinks.map((link) => (
                <a
                    key={link.id}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 font-font-s bg-main-color/10 text-main-color rounded-lg hover:bg-main-color/20 hover:shadow transition-all px-3 py-2 text-sm backdrop-blur-sm border border-main-color/20"
                >
                    {link.name}
                    <ExternalLink className="w-3 h-3 opacity-50" />
                </a>
            ))}
        </nav>
    );
}
